export function clampPlayheadMs(value: unknown, durationMs: unknown): number {
  const numeric = Number(value)
  const duration = Math.max(0, Number(durationMs) || 0)
  if (!Number.isFinite(numeric)) return 0
  const normalized = Math.max(0, Math.round(numeric))
  return duration > 0 ? Math.min(duration, normalized) : normalized
}

export function playheadFromElapsedMs(startMs: unknown, elapsedMs: unknown, durationMs: unknown): number {
  const start = Math.max(0, Number(startMs) || 0)
  const elapsed = Math.max(0, Number(elapsedMs) || 0)
  return clampPlayheadMs(start + elapsed, durationMs)
}

export function naturalTakeEndMs(
  timelineStartMs: unknown,
  durationMs: unknown,
  offsetMs: unknown,
): number {
  const start = Math.max(0, Number(timelineStartMs) || 0)
  const duration = Math.max(0, Number(durationMs) || 0)
  const offset = Math.max(0, Number(offsetMs) || 0)
  return Math.max(start, start + duration - offset)
}
